import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FULFILLMENT_STATUS_OPTIONS, FulfillmentStatusLabel } from "../../types/alerts";

interface FulfillmentStatusSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function FulfillmentStatusSelect({
  value,
  onChange,
  disabled = false,
}: FulfillmentStatusSelectProps) {
  return (
    <FormControl size="small" fullWidth required disabled={disabled}>
      <InputLabel id="fulfillment-status-label">Fulfillment Status</InputLabel>
      <Select
        labelId="fulfillment-status-label"
        id="fulfillment-status"
        value={value}
        label="Fulfillment Status"
        onChange={(e) => onChange(e.target.value)}
      >
        {FULFILLMENT_STATUS_OPTIONS.map((status) => (
          <MenuItem key={status} value={status}>
            {FulfillmentStatusLabel[status]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
